import 'isomorphic-fetch';
import FileSaver from 'file-saver';
import {SESSION_KEY, loadData} from '../storage/local-storage';

export default function (url, filename) {
    const {access_token: token} = loadData(SESSION_KEY);
    const config = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: `Bearer ${token}`
        }
    };

    return fetch(url, config).then(function(response) {
        return response.blob();
    }).then(function(blob) {
        FileSaver.saveAs(blob, filename);
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/util/fileDownload.js